import axios from "axios";
import settings from "utils/settings";

const { apiUrl } = settings;

const exportOrdersUrl = `${apiUrl}orderExport`;

export const orderExportLayoutsGet = () =>
    axios.get(`${exportOrdersUrl}/layouts`);

export const orderExportHistoryGet = (supplierId, jobId, fromDate, toDate) =>
    axios.get(`${exportOrdersUrl}/history?supplierId=${supplierId}&jobId=${jobId}&fromDate=${fromDate}&toDate=${toDate}`);

export const orderNotExportedGet = (supplierId, jobId) =>
    axios.get(`${exportOrdersUrl}?supplierId=${supplierId}&jobId=${jobId}`);

export const fetchExportOrdersExcel = (orderLayoutId, supplierId, data) =>
    axios.post(`${exportOrdersUrl}/excel/?orderLayoutId=${orderLayoutId}&supplierId=${supplierId}`, data,  {
        responseType: "blob"
    });
